<template>
  <div class="mobile-top-up">
    <div>
      <div class="phone-number-form">
        <svg-icon name="ais_icon" class="ais_icon" />
        <md-input-item
          v-model="phone"
          :title="$t('mobileNumber')"
          is-title-latent
          preview-type="text"
          size="large"
          class="phone-number-disabled"
          disabled
        />
      </div>
      <div class="top-up-result">
        <div class="result-list-info">
          <md-field>
            <md-detail-item
              class="amount_text"
              :title="$t('amount')"
              :content="`Rp${amount}`"
            />
            <md-detail-item
              :title="$t('transactionType')"
              :content="$t('mobile_phone_top-up')"
            />
            <md-detail-item
              :title="$t('mobileNumber')"
              :content="phone"
            />
            <md-detail-item
              :title="$t('transaction_fee')"
              :content="`Rp${fee}`"
            />
            <md-detail-item
              class="Order No."
              :title="$t('totalAmount')"
              :content="`Rp${amount}.00`"
            />
          </md-field>
        </div>
      </div>
    </div>
    <div class="top-up-pay-btn">
      <md-button class="mr40" @click="back">{{ $t('back') }}</md-button>
      <md-button type="primary" @click="topUpHandel">{{ $t('done') }}</md-button>
    </div>
    <!-- 支付键盘 -->
    <PasswordPopup
      v-model="passwordVisiable"
      :code.sync="password"
      :error.sync="passwordError"
      @finished="confirmMethod"
    />
    <!-- 控制支付loading -->
    <PayLoading :is-show="isShow" />
  </div>
</template>

<script>
import { InputItem, Field, RadioGroup, RadioBox, Button, DetailItem, Toast } from 'mand-mobile'
import yuanToFen from '@/utils/yuan-to-fen'
import { ERROR_REQ_CODE, UTILITIES_ORDER_STATUS } from '@/constants'
import PasswordPopup from '@/components/PasswordPopup'
import PayLoading from '@/components/PayLoading'
import { topUp, topUpDetail } from '@/api/mobile-top-up'
// 手机充值支付
export default {
  name: 'MobileTopUpPay',

  components: {
    [Field.name]: Field,
    [RadioGroup.name]: RadioGroup,
    [RadioBox.name]: RadioBox,
    [Button.name]: Button,
    [InputItem.name]: InputItem,
    [DetailItem.name]: DetailItem,
    [Toast.name]: Toast,
    PasswordPopup,
    PayLoading
  },

  data () {
    return {
      password: '', // 密码
      passwordVisiable: false, // 密码键盘
      passwordError: '', // 密码报错提示信息
      isShow: false,
      phone: this.$route.query.phone,
      amount: this.$route.query.amount,
      fee: '0.00'
    }
  },

  methods: {
    topUpHandel () {
      // 充值按钮
      this.passwordVisiable = true // 密码键盘弹起
    },
    async confirmMethod (password) {
      try {
        this.isShow = true // 支付loading弹起
        this.passwordVisiable = false
        const { utilitiesNo } = await topUp({
          password, // 密码
          paymentAmount: yuanToFen(this.amount), // 金额
          mobileNo: this.phone, // 手机号
          utilitiesType: 1 // 公共事业类型
        }) // 键盘密码接口
        this.utilitiesNo = utilitiesNo // 定时器中用到的参数
        this.createInterval()
      } catch (e) {
        this.isShow = false
        this.passwordVisiable = false // 键盘隐藏
        if (e.code === ERROR_REQ_CODE.passError) {
          // 密码错误
          this.passwordVisiable = true // 键盘显示
          this.passwordError = e.message
        } else {
          e.code && Toast.failed(e.message, 4000, null, document.body, true)
        }
      }
    },
    async queryTradeDetail (utilitiesNo, countdown) {
      const { status } = await topUpDetail({ utilitiesNo }, (cancel) => {
        this.peddingCancel = cancel
      })
      // 如果为处理中先继续查询
      if (status.code === UTILITIES_ORDER_STATUS.processing) {
        // 银行受理中、银行处理中5S内继续请求
        this.peddingCancel = false
        if (countdown === 0) {
          // 5S内继续请求完后结果还是银行受理中或者银行处理中跳转到等待处理页面
          this.isShow = false
          this.$router.replace({
            name: 'MobileTopUpResult',
            query: { utilitiesNo }
          })
        }
      } else {
        // 清除定时器
        this.clearInterval()
        this.isShow = false
        this.$router.replace({ name: 'MobileTopUpResult', query: { utilitiesNo } })
      }
    },
    clearInterval () {
      if (this.peddingCancel) {
        this.peddingCancel() // 终止请求
      }
      clearInterval(this.timer)
    },
    createInterval () {
      let countdown = 4
      const time = 1000
      this.timer = setInterval(() => {
        if (countdown <= 0) {
          this.isShow = false
          this.clearInterval()
        } else if (!this.peddingCancel) {
          countdown--
          this.queryTradeDetail(this.utilitiesNo, countdown)
        }
      }, time)
    },
    // 返回
    back () {
      this.$router.push({
        name: 'MobileTopUp'
      })
    }
  }
}
</script>

<style scoped lang="scss">
.mobile-top-up {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 100px;
  min-height: 100%;
}

.phone-number-form {
  padding: 68px 64px 100px;
  background: #fff;
  border-radius: 0 0 72px 72px;
  box-shadow: 0 8px 32px 0 rgba(138, 149, 158, 0.2);

  .phone-number-disabled {
    ::v-deep .md-input-item-input {
      -webkit-text-fill-color: #131a34;
      color: #131a34;
    }
  }

  .ais_icon {
    width: 92px;
    height: 64px;
    margin-bottom: 40px;
  }

  ::v-deep {
    .md-field-item-content {
      height: 230px;

      &::before {
        border-color: #f0f0f0;
        z-index: 1;
      }
    }
  }
}

.top-up-result {
  padding: 30px 40px;
}

.top-up-pay-btn {
  padding: 0 40px;
  display: flex;
}
</style>
